import React, { Component } from 'react';

import {
    Form, Row, Col, Button, TimePicker, Radio, Input, Card,
} from 'antd';
import moment from 'moment';

import DoseTimeDirectionPool from '../DoseTimeDirectionPool/DoseTimeDirectionPool';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const format = 'h:mm A';

class UnwrappedDoseTwo extends Component {
    state = {
        checkedValue: '',
        times: [],
    }

    componentDidMount = () => {
        const { data } = this.props;
        const {
            time_1, direction_1, time_2, direction_2,
        } = data;
        if (time_1 !== undefined) {
            this.setState({
                times: [[time_1, direction_1], [time_2, direction_2]],
            });
        }
    }


    onChange = (e) => {
        this.setState({
            checkedValue: e.target.value,
        });
    }

    handleAddTime = (button) => {
        const { times } = this.state;

        if (times.length === 0) {
            this.setState({
                times: [button],
            });
        } else {
            this.setState({ times: times.concat([button]) }, () => {
                console.log(JSON.stringify(this.state));
            });
        }
    }

    handleResetPool = () => {
        this.setState({
            times: [],
        });
    }

    handleMidSubmit = (e) => {
        e.preventDefault();

        const {
            form, handleDoseDirection, handleSubmitFromDosageDirection, onCancel,
        } = this.props;

        form.validateFields((err, values) => {
            if (!err) {
                this.handleFinal(values);
                handleDoseDirection(values);
                handleSubmitFromDosageDirection(values);
            }
        });
        onCancel();
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const { form, handleDoseDirection, changeActiveKey } = this.props;

        form.validateFields((err, values) => {
            if (!err) {
                this.handleFinal(values);
                handleDoseDirection(values);
                changeActiveKey('3');
            }
        });
    }

    handleFinal = (values) => {
        if (values.direction_1 === 'custom') {
            values.direction_1 = values.cfd1;
        }
        if (values.direction_2 === 'custom') {
            values.direction_2 = values.cfd2;
        }
        values.time_1 = moment(values.time_1).format('hh:mm A');
        values.time_2 = moment(values.time_2).format('hh:mm A');
        values.dosage_direction = 2;
        values.time_3 = '';
        values.direction_3 = '';
        values.time_4 = '';
        values.direction_4 = '';

        delete values.cfd1;
        delete values.cfd2;
    };

    render() {
        const { form, changeActiveKey, data } = this.props;
        const { getFieldDecorator, getFieldValue } = form;
        const { times } = this.state;

        const directionArray = ['Before Food', 'After Food', 'No Food Direction', 'With Food'];

        return (
            <div>

                <Form onSubmit={this.handleSubmit}>

                    <Card>
                        <Row type="flex" justify="center" align="middle">

                            <Col span={5}>
                                <FormItem>
                                    {getFieldDecorator('time_1', {
                                        rules: [{ required: false, message: 'Select time please!' }],
                                        initialValue: times.length > 0
                                            ? moment(times[0][0], format)
                                            : '',
                                    })(
                                        <TimePicker
                                            use12Hours
                                            format={format}
                                            minuteStep={15}
                                            placeholder="Time1"
                                            defaultOpenValue={moment().startOf('day')}

                                        />,
                                    )}
                                </FormItem>
                            </Col>

                            <Col span={19}>
                                <FormItem>
                                    {getFieldDecorator('direction_1', {
                                        rules: [{ required: false, message: 'Select One please!' }],
                                        initialValue: times.length > 0
                                            ? directionArray.includes(times[0][1])
                                                ? times[0][1]
                                                : 'custom'
                                            : '',
                                    })(
                                        <RadioGroup size="small" onChange={this.onChange}>
                                            <Radio value="Before Food">Before Food</Radio>
                                            <Radio value="After Food">After Food</Radio>
                                            <Radio value="No Food Direction">No Food Direction</Radio>
                                            <Radio value="With Food">With Food</Radio>
                                            <Radio value="custom">
                                                Custom
                                                {getFieldDecorator('cfd1', {
                                                    rules: [{ required: getFieldValue('direction_1') === 'custom', message: 'Please select a expiry date!' }],
                                                    initialValue: getFieldValue('direction_1') === 'custom'
                                                        ? times.length > 0
                                                            ? times[0][1]
                                                            : ''
                                                        : '',
                                                })(
                                                    <Input disabled={getFieldValue('direction_1') !== 'custom'} style={{ width: 100, marginLeft: 10 }} />,
                                                )}
                                            </Radio>
                                        </RadioGroup>,
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </Card>

                    <Card>
                        <Row type="flex" justify="center" align="middle">

                            <Col span={5}>
                                <FormItem>
                                    {getFieldDecorator('time_2', {
                                        rules: [{ required: false, message: 'Select time please!' }],
                                        initialValue: times.length > 1
                                            ? moment(times[1][0], format)
                                            : '',
                                    })(
                                        <TimePicker
                                            use12Hours
                                            format={format}
                                            minuteStep={15}
                                            placeholder="Time2"
                                            defaultOpenValue={moment().startOf('day')}

                                        />,
                                    )}
                                </FormItem>
                            </Col>

                            <Col span={19}>
                                <FormItem>
                                    {getFieldDecorator('direction_2', {
                                        rules: [{ required: false, message: 'Select One please!' }],
                                        initialValue: times.length > 1
                                            ? directionArray.includes(times[1][1])
                                                ? times[1][1]
                                                : 'custom'
                                            : '',
                                    })(
                                        <RadioGroup size="small" onChange={this.onChange}>
                                            <Radio value="Before Food">Before Food</Radio>
                                            <Radio value="After Food">After Food</Radio>
                                            <Radio value="No Food Direction">No Food Direction</Radio>
                                            <Radio value="With Food">With Food</Radio>
                                            <Radio value="custom">
                                                Custom
                                                {getFieldDecorator('cfd2', {
                                                    rules: [{ required: getFieldValue('direction_2') === 'custom', message: 'Please select a expiry date!' }],
                                                    initialValue: getFieldValue('direction_2') === 'custom'
                                                        ? times.length > 1
                                                            ? times[1][1]
                                                            : ''
                                                        : '',
                                                })(
                                                    <Input disabled={getFieldValue('direction_2') !== 'custom'} style={{ width: 100, marginLeft: 10 }} />,
                                                )}
                                            </Radio>
                                        </RadioGroup>,
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </Card>

                    <div style={{ margin: '50px 0 50px 0' }}>
                        <DoseTimeDirectionPool
                            handleAddTime={this.handleAddTime}
                            onReset={this.handleResetPool}
                        />
                    </div>

                    <Row type="flex" justify="space-around" style={{ marginTop: '5%' }}>
                        <Col>
                            <FormItem>
                                <Button type="primary" onClick={() => changeActiveKey('1')}>To Prev</Button>
                            </FormItem>
                        </Col>
                        <Col>
                            <FormItem>
                                <Button type="primary" htmlType="submit">To Next</Button>
                            </FormItem>
                        </Col>
                        {
                            (Object.keys(data).length > 0)
                                ? (
                                    <Col>
                                        <FormItem>
                                            <Button type="primary" onClick={this.handleMidSubmit}>Submit</Button>
                                        </FormItem>
                                    </Col>
                                )
                                : null
                        }
                    </Row>


                </Form>

            </div>
        );
    }
}

const DoseTwo = Form.create()(UnwrappedDoseTwo);

export default DoseTwo;



// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/DosageDirectionHelper/DoseTwo.js